import { Storage } from '@ionic/storage';

export class NoopStorage extends Storage {
  constructor() {
    super();
  }
  override async create() {
    return this;
  }
  override async defineDriver() {}
  override get driver(): string | null {
    return 'noop';
  }
  override async get(_key: string) {
    return null;
  }
  override async set(_key: string, _value: unknown) {}
  override async remove(_key: string): Promise<unknown> {
    return undefined;
  }
  override async clear(): Promise<void> {}
  override async length(): Promise<number> {
    return 0;
  }
  override async keys() {
    return [];
  }
  override async forEach(_iteratorCallback: (value: unknown, key: string, iterationNumber: number) => unknown): Promise<void> {}
  override setEncryptionKey(_key: string) {}
}
